import Service from '../Service';
import { ResponseErrorBody, ResponseSuccessGetPasswordSet } from '../../types';
import Request from '../Request';
import { addFingerprintToRequest } from './utils';

export default async function(webToken: string) {
  const request = await addFingerprintToRequest(
    new Request(`/api/auth/login/${webToken}/password/set`).setMethod('GET')
  );
  const service = new Service<ResponseSuccessGetPasswordSet, ResponseErrorBody>(
    request
  );
  return await service.send();
}
